// This file is auto-generated by @hey-api/openapi-ts

import {
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query";

import { client } from "../client.gen";
import {
  applyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPost,
  boomBoomGet,
  createFinancialHelpFinancialHelpsPost,
  createPostingHohishesHohishUuidPostingsPost,
  createZoneGeographiesZonesPost,
  deleteAgencyGeographiesAgenciesAgencyUuidDelete,
  deletePostalCodesBindingGeographiesPostalCodesBindingDelete,
  deletePostingHohishesHohishUuidPostingsPostingUuidDelete,
  deleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDelete,
  getAgenciesGeographiesAgenciesGet,
  getAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGet,
  getAstreinteMailsAircallMfaAstreinteMailsGet,
  getDepartmentsGeographiesDepartmentsGet,
  getExternalProvidersErrorsExternalProvidersErrorsGet,
  getFinancialHelpsFinancialHelpsGet,
  getHohishesHohishesGet,
  getHohishHohishesHohishUuidGet,
  getJobsHohishesJobsGet,
  getLegalEntityLegalEntitiesGet,
  getMeHohishesMeGet,
  getPostalCodesGeographiesPostalCodesGet,
  getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGet,
  getPostingsHohishesHohishUuidPostingsGet,
  getRegionsGeographiesRegionsGet,
  getSecurityPolicyPermerSecurityPolicyGet,
  getUrbanAreasGeographiesUrbanAreasGet,
  getZonesGeographiesZonesGet,
  type Options,
  patchHohishHohishesHohishUuidPatch,
  postAgencyGeographiesAgenciesPost,
  postUrbanAreaGeographiesUrbanAreasPost,
  previewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPost,
  putAgencyGeographiesAgenciesAgencyUuidPut,
  putUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPut,
  statusDbStatusDbGet,
  statusStatusGet,
  updateFinancialHelpFinancialHelpsHelpUuidPut,
  updatePostingHohishesHohishUuidPostingsPostingUuidPost,
  updateZoneGeographiesZonesZoneUuidPut,
  upsertPostalCodesBindingGeographiesPostalCodesBindingPut,
} from "../sdk.gen";

import type {
  ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostData,
  ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostError,
  ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostResponse,
  BoomBoomGetData,
  CreateFinancialHelpFinancialHelpsPostData,
  CreateFinancialHelpFinancialHelpsPostError,
  CreateFinancialHelpFinancialHelpsPostResponse,
  CreatePostingHohishesHohishUuidPostingsPostData,
  CreatePostingHohishesHohishUuidPostingsPostError,
  CreatePostingHohishesHohishUuidPostingsPostResponse,
  CreateZoneGeographiesZonesPostData,
  CreateZoneGeographiesZonesPostError,
  CreateZoneGeographiesZonesPostResponse,
  DeleteAgencyGeographiesAgenciesAgencyUuidDeleteData,
  DeleteAgencyGeographiesAgenciesAgencyUuidDeleteError,
  DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteData,
  DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteError,
  DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteData,
  DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteError,
  DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteData,
  DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteError,
  GetAgenciesGeographiesAgenciesGetData,
  GetAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetData,
  GetAstreinteMailsAircallMfaAstreinteMailsGetData,
  GetDepartmentsGeographiesDepartmentsGetData,
  GetExternalProvidersErrorsExternalProvidersErrorsGetData,
  GetExternalProvidersErrorsExternalProvidersErrorsGetError,
  GetExternalProvidersErrorsExternalProvidersErrorsGetResponse,
  GetFinancialHelpsFinancialHelpsGetData,
  GetHohishesHohishesGetData,
  GetHohishHohishesHohishUuidGetData,
  GetJobsHohishesJobsGetData,
  GetLegalEntityLegalEntitiesGetData,
  GetMeHohishesMeGetData,
  GetPostalCodesGeographiesPostalCodesGetData,
  GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData,
  GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetError,
  GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetResponse,
  GetPostingsHohishesHohishUuidPostingsGetData,
  GetRegionsGeographiesRegionsGetData,
  GetSecurityPolicyPermerSecurityPolicyGetData,
  GetUrbanAreasGeographiesUrbanAreasGetData,
  GetZonesGeographiesZonesGetData,
  PatchHohishHohishesHohishUuidPatchData,
  PatchHohishHohishesHohishUuidPatchError,
  PatchHohishHohishesHohishUuidPatchResponse,
  PostAgencyGeographiesAgenciesPostData,
  PostAgencyGeographiesAgenciesPostError,
  PostAgencyGeographiesAgenciesPostResponse,
  PostUrbanAreaGeographiesUrbanAreasPostData,
  PostUrbanAreaGeographiesUrbanAreasPostError,
  PostUrbanAreaGeographiesUrbanAreasPostResponse,
  PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostData,
  PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostError,
  PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostResponse,
  PutAgencyGeographiesAgenciesAgencyUuidPutData,
  PutAgencyGeographiesAgenciesAgencyUuidPutError,
  PutAgencyGeographiesAgenciesAgencyUuidPutResponse,
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutData,
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutError,
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutResponse,
  StatusDbStatusDbGetData,
  StatusStatusGetData,
  UpdateFinancialHelpFinancialHelpsHelpUuidPutData,
  UpdateFinancialHelpFinancialHelpsHelpUuidPutError,
  UpdateFinancialHelpFinancialHelpsHelpUuidPutResponse,
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostData,
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostError,
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostResponse,
  UpdateZoneGeographiesZonesZoneUuidPutData,
  UpdateZoneGeographiesZonesZoneUuidPutError,
  UpdateZoneGeographiesZonesZoneUuidPutResponse,
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutData,
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutError,
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutResponse,
} from "../types.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getAstreinteMailsAircallMfaAstreinteMailsGetQueryKey = (
  options?: Options<GetAstreinteMailsAircallMfaAstreinteMailsGetData>
) => createQueryKey("getAstreinteMailsAircallMfaAstreinteMailsGet", options);

/**
 * Get Astreinte Mails
 *
 * Return all emails sent to bonjour+astreinteN@ouihelp.fr in the last 6 hours.
 */
export const getAstreinteMailsAircallMfaAstreinteMailsGetOptions = (
  options?: Options<GetAstreinteMailsAircallMfaAstreinteMailsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAstreinteMailsAircallMfaAstreinteMailsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAstreinteMailsAircallMfaAstreinteMailsGetQueryKey(options),
  });
};

export const getExternalProvidersErrorsExternalProvidersErrorsGetQueryKey = (
  options?: Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>
) => createQueryKey("getExternalProvidersErrorsExternalProvidersErrorsGet", options);

/**
 * Get External Providers Errors
 */
export const getExternalProvidersErrorsExternalProvidersErrorsGetOptions = (
  options?: Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExternalProvidersErrorsExternalProvidersErrorsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExternalProvidersErrorsExternalProvidersErrorsGetQueryKey(options),
  });
};

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = {
    ...queryKey[0],
  };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getExternalProvidersErrorsExternalProvidersErrorsGetInfiniteQueryKey = (
  options?: Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>
): QueryKey<Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>> =>
  createQueryKey("getExternalProvidersErrorsExternalProvidersErrorsGet", options, true);

/**
 * Get External Providers Errors
 */
export const getExternalProvidersErrorsExternalProvidersErrorsGetInfiniteOptions = (
  options?: Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>
) => {
  return infiniteQueryOptions<
    GetExternalProvidersErrorsExternalProvidersErrorsGetResponse,
    GetExternalProvidersErrorsExternalProvidersErrorsGetError,
    InfiniteData<GetExternalProvidersErrorsExternalProvidersErrorsGetResponse>,
    QueryKey<Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getExternalProvidersErrorsExternalProvidersErrorsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getExternalProvidersErrorsExternalProvidersErrorsGetInfiniteQueryKey(options),
    }
  );
};

export const getFinancialHelpsFinancialHelpsGetQueryKey = (
  options?: Options<GetFinancialHelpsFinancialHelpsGetData>
) => createQueryKey("getFinancialHelpsFinancialHelpsGet", options);

/**
 * Get Financial Helps
 */
export const getFinancialHelpsFinancialHelpsGetOptions = (
  options?: Options<GetFinancialHelpsFinancialHelpsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFinancialHelpsFinancialHelpsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFinancialHelpsFinancialHelpsGetQueryKey(options),
  });
};

/**
 * Create Financial Help
 */
export const createFinancialHelpFinancialHelpsPostMutation = (
  options?: Partial<Options<CreateFinancialHelpFinancialHelpsPostData>>
): UseMutationOptions<
  CreateFinancialHelpFinancialHelpsPostResponse,
  CreateFinancialHelpFinancialHelpsPostError,
  Options<CreateFinancialHelpFinancialHelpsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateFinancialHelpFinancialHelpsPostResponse,
    CreateFinancialHelpFinancialHelpsPostError,
    Options<CreateFinancialHelpFinancialHelpsPostData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createFinancialHelpFinancialHelpsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Financial Help
 */
export const updateFinancialHelpFinancialHelpsHelpUuidPutMutation = (
  options?: Partial<Options<UpdateFinancialHelpFinancialHelpsHelpUuidPutData>>
): UseMutationOptions<
  UpdateFinancialHelpFinancialHelpsHelpUuidPutResponse,
  UpdateFinancialHelpFinancialHelpsHelpUuidPutError,
  Options<UpdateFinancialHelpFinancialHelpsHelpUuidPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateFinancialHelpFinancialHelpsHelpUuidPutResponse,
    UpdateFinancialHelpFinancialHelpsHelpUuidPutError,
    Options<UpdateFinancialHelpFinancialHelpsHelpUuidPutData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateFinancialHelpFinancialHelpsHelpUuidPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetQueryKey = (
  options?: Options<GetAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetData>
) =>
  createQueryKey(
    "getAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGet",
    options
  );

/**
 * Get Agencies Postal Codes Bindings
 */
export const getAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetOptions = (
  options?: Options<GetAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await getAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGet({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      getAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetQueryKey(options),
  });
};

export const getPostalCodesGeographiesPostalCodesGetQueryKey = (
  options?: Options<GetPostalCodesGeographiesPostalCodesGetData>
) => createQueryKey("getPostalCodesGeographiesPostalCodesGet", options);

/**
 * Get Postal Codes
 */
export const getPostalCodesGeographiesPostalCodesGetOptions = (
  options?: Options<GetPostalCodesGeographiesPostalCodesGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPostalCodesGeographiesPostalCodesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPostalCodesGeographiesPostalCodesGetQueryKey(options),
  });
};

export const getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetQueryKey = (
  options?: Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>
) => createQueryKey("getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGet", options);

/**
 * Get Postal Codes With Bindings
 */
export const getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetOptions = (
  options?: Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetQueryKey(options),
  });
};

export const getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetInfiniteQueryKey = (
  options?: Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>
): QueryKey<Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>> =>
  createQueryKey("getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGet", options, true);

/**
 * Get Postal Codes With Bindings
 */
export const getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetInfiniteOptions = (
  options?: Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>
) => {
  return infiniteQueryOptions<
    GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetResponse,
    GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetError,
    InfiniteData<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetResponse>,
    QueryKey<Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey:
        getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetInfiniteQueryKey(options),
    }
  );
};

/**
 * Delete Postal Codes Binding
 */
export const deletePostalCodesBindingGeographiesPostalCodesBindingDeleteMutation = (
  options?: Partial<Options<DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteData>>
): UseMutationOptions<
  unknown,
  DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteError,
  Options<DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteError,
    Options<DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deletePostalCodesBindingGeographiesPostalCodesBindingDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Upsert Postal Codes Binding
 */
export const upsertPostalCodesBindingGeographiesPostalCodesBindingPutMutation = (
  options?: Partial<Options<UpsertPostalCodesBindingGeographiesPostalCodesBindingPutData>>
): UseMutationOptions<
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutResponse,
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutError,
  Options<UpsertPostalCodesBindingGeographiesPostalCodesBindingPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertPostalCodesBindingGeographiesPostalCodesBindingPutResponse,
    UpsertPostalCodesBindingGeographiesPostalCodesBindingPutError,
    Options<UpsertPostalCodesBindingGeographiesPostalCodesBindingPutData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await upsertPostalCodesBindingGeographiesPostalCodesBindingPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Preview Postal Codes Import
 */
export const previewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostMutation =
  (
    options?: Partial<
      Options<PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostData>
    >
  ): UseMutationOptions<
    PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostResponse,
    PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostError,
    Options<PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostResponse,
      PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostError,
      Options<PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostData>
    > = {
      mutationFn: async fnOptions => {
        const { data } =
          await previewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPost({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Apply Postal Codes Import
 */
export const applyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostMutation =
  (
    options?: Partial<
      Options<ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostData>
    >
  ): UseMutationOptions<
    ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostResponse,
    ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostError,
    Options<ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostResponse,
      ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostError,
      Options<ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostData>
    > = {
      mutationFn: async fnOptions => {
        const { data } =
          await applyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPost({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const getRegionsGeographiesRegionsGetQueryKey = (
  options?: Options<GetRegionsGeographiesRegionsGetData>
) => createQueryKey("getRegionsGeographiesRegionsGet", options);

/**
 * Get Regions
 */
export const getRegionsGeographiesRegionsGetOptions = (
  options?: Options<GetRegionsGeographiesRegionsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRegionsGeographiesRegionsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRegionsGeographiesRegionsGetQueryKey(options),
  });
};

export const getZonesGeographiesZonesGetQueryKey = (
  options?: Options<GetZonesGeographiesZonesGetData>
) => createQueryKey("getZonesGeographiesZonesGet", options);

/**
 * Get Zones
 */
export const getZonesGeographiesZonesGetOptions = (
  options?: Options<GetZonesGeographiesZonesGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getZonesGeographiesZonesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getZonesGeographiesZonesGetQueryKey(options),
  });
};

/**
 * Create Zone
 */
export const createZoneGeographiesZonesPostMutation = (
  options?: Partial<Options<CreateZoneGeographiesZonesPostData>>
): UseMutationOptions<
  CreateZoneGeographiesZonesPostResponse,
  CreateZoneGeographiesZonesPostError,
  Options<CreateZoneGeographiesZonesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateZoneGeographiesZonesPostResponse,
    CreateZoneGeographiesZonesPostError,
    Options<CreateZoneGeographiesZonesPostData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createZoneGeographiesZonesPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Zone
 */
export const updateZoneGeographiesZonesZoneUuidPutMutation = (
  options?: Partial<Options<UpdateZoneGeographiesZonesZoneUuidPutData>>
): UseMutationOptions<
  UpdateZoneGeographiesZonesZoneUuidPutResponse,
  UpdateZoneGeographiesZonesZoneUuidPutError,
  Options<UpdateZoneGeographiesZonesZoneUuidPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateZoneGeographiesZonesZoneUuidPutResponse,
    UpdateZoneGeographiesZonesZoneUuidPutError,
    Options<UpdateZoneGeographiesZonesZoneUuidPutData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateZoneGeographiesZonesZoneUuidPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAgenciesGeographiesAgenciesGetQueryKey = (
  options?: Options<GetAgenciesGeographiesAgenciesGetData>
) => createQueryKey("getAgenciesGeographiesAgenciesGet", options);

/**
 * Get Agencies
 */
export const getAgenciesGeographiesAgenciesGetOptions = (
  options?: Options<GetAgenciesGeographiesAgenciesGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAgenciesGeographiesAgenciesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAgenciesGeographiesAgenciesGetQueryKey(options),
  });
};

/**
 * Post Agency
 */
export const postAgencyGeographiesAgenciesPostMutation = (
  options?: Partial<Options<PostAgencyGeographiesAgenciesPostData>>
): UseMutationOptions<
  PostAgencyGeographiesAgenciesPostResponse,
  PostAgencyGeographiesAgenciesPostError,
  Options<PostAgencyGeographiesAgenciesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    PostAgencyGeographiesAgenciesPostResponse,
    PostAgencyGeographiesAgenciesPostError,
    Options<PostAgencyGeographiesAgenciesPostData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await postAgencyGeographiesAgenciesPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Agency
 */
export const deleteAgencyGeographiesAgenciesAgencyUuidDeleteMutation = (
  options?: Partial<Options<DeleteAgencyGeographiesAgenciesAgencyUuidDeleteData>>
): UseMutationOptions<
  unknown,
  DeleteAgencyGeographiesAgenciesAgencyUuidDeleteError,
  Options<DeleteAgencyGeographiesAgenciesAgencyUuidDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteAgencyGeographiesAgenciesAgencyUuidDeleteError,
    Options<DeleteAgencyGeographiesAgenciesAgencyUuidDeleteData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteAgencyGeographiesAgenciesAgencyUuidDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Put Agency
 */
export const putAgencyGeographiesAgenciesAgencyUuidPutMutation = (
  options?: Partial<Options<PutAgencyGeographiesAgenciesAgencyUuidPutData>>
): UseMutationOptions<
  PutAgencyGeographiesAgenciesAgencyUuidPutResponse,
  PutAgencyGeographiesAgenciesAgencyUuidPutError,
  Options<PutAgencyGeographiesAgenciesAgencyUuidPutData>
> => {
  const mutationOptions: UseMutationOptions<
    PutAgencyGeographiesAgenciesAgencyUuidPutResponse,
    PutAgencyGeographiesAgenciesAgencyUuidPutError,
    Options<PutAgencyGeographiesAgenciesAgencyUuidPutData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await putAgencyGeographiesAgenciesAgencyUuidPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getUrbanAreasGeographiesUrbanAreasGetQueryKey = (
  options?: Options<GetUrbanAreasGeographiesUrbanAreasGetData>
) => createQueryKey("getUrbanAreasGeographiesUrbanAreasGet", options);

/**
 * Get Urban Areas
 */
export const getUrbanAreasGeographiesUrbanAreasGetOptions = (
  options?: Options<GetUrbanAreasGeographiesUrbanAreasGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUrbanAreasGeographiesUrbanAreasGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUrbanAreasGeographiesUrbanAreasGetQueryKey(options),
  });
};

/**
 * Post Urban Area
 */
export const postUrbanAreaGeographiesUrbanAreasPostMutation = (
  options?: Partial<Options<PostUrbanAreaGeographiesUrbanAreasPostData>>
): UseMutationOptions<
  PostUrbanAreaGeographiesUrbanAreasPostResponse,
  PostUrbanAreaGeographiesUrbanAreasPostError,
  Options<PostUrbanAreaGeographiesUrbanAreasPostData>
> => {
  const mutationOptions: UseMutationOptions<
    PostUrbanAreaGeographiesUrbanAreasPostResponse,
    PostUrbanAreaGeographiesUrbanAreasPostError,
    Options<PostUrbanAreaGeographiesUrbanAreasPostData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await postUrbanAreaGeographiesUrbanAreasPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Urban Area
 */
export const deleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteMutation = (
  options?: Partial<Options<DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteData>>
): UseMutationOptions<
  unknown,
  DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteError,
  Options<DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteError,
    Options<DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Put Urban Area
 */
export const putUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutMutation = (
  options?: Partial<Options<PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutData>>
): UseMutationOptions<
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutResponse,
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutError,
  Options<PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutData>
> => {
  const mutationOptions: UseMutationOptions<
    PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutResponse,
    PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutError,
    Options<PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await putUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDepartmentsGeographiesDepartmentsGetQueryKey = (
  options?: Options<GetDepartmentsGeographiesDepartmentsGetData>
) => createQueryKey("getDepartmentsGeographiesDepartmentsGet", options);

/**
 * Get Departments
 */
export const getDepartmentsGeographiesDepartmentsGetOptions = (
  options?: Options<GetDepartmentsGeographiesDepartmentsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDepartmentsGeographiesDepartmentsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDepartmentsGeographiesDepartmentsGetQueryKey(options),
  });
};

export const getJobsHohishesJobsGetQueryKey = (options?: Options<GetJobsHohishesJobsGetData>) =>
  createQueryKey("getJobsHohishesJobsGet", options);

/**
 * Get Jobs
 */
export const getJobsHohishesJobsGetOptions = (options?: Options<GetJobsHohishesJobsGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobsHohishesJobsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobsHohishesJobsGetQueryKey(options),
  });
};

export const getHohishesHohishesGetQueryKey = (options?: Options<GetHohishesHohishesGetData>) =>
  createQueryKey("getHohishesHohishesGet", options);

/**
 * Get Hohishes
 */
export const getHohishesHohishesGetOptions = (options?: Options<GetHohishesHohishesGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHohishesHohishesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHohishesHohishesGetQueryKey(options),
  });
};

export const getMeHohishesMeGetQueryKey = (options?: Options<GetMeHohishesMeGetData>) =>
  createQueryKey("getMeHohishesMeGet", options);

/**
 * Get Me
 */
export const getMeHohishesMeGetOptions = (options?: Options<GetMeHohishesMeGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMeHohishesMeGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeHohishesMeGetQueryKey(options),
  });
};

export const getHohishHohishesHohishUuidGetQueryKey = (
  options: Options<GetHohishHohishesHohishUuidGetData>
) => createQueryKey("getHohishHohishesHohishUuidGet", options);

/**
 * Get Hohish
 */
export const getHohishHohishesHohishUuidGetOptions = (
  options: Options<GetHohishHohishesHohishUuidGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHohishHohishesHohishUuidGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHohishHohishesHohishUuidGetQueryKey(options),
  });
};

/**
 * Patch Hohish
 */
export const patchHohishHohishesHohishUuidPatchMutation = (
  options?: Partial<Options<PatchHohishHohishesHohishUuidPatchData>>
): UseMutationOptions<
  PatchHohishHohishesHohishUuidPatchResponse,
  PatchHohishHohishesHohishUuidPatchError,
  Options<PatchHohishHohishesHohishUuidPatchData>
> => {
  const mutationOptions: UseMutationOptions<
    PatchHohishHohishesHohishUuidPatchResponse,
    PatchHohishHohishesHohishUuidPatchError,
    Options<PatchHohishHohishesHohishUuidPatchData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await patchHohishHohishesHohishUuidPatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPostingsHohishesHohishUuidPostingsGetQueryKey = (
  options: Options<GetPostingsHohishesHohishUuidPostingsGetData>
) => createQueryKey("getPostingsHohishesHohishUuidPostingsGet", options);

/**
 * Get Postings
 */
export const getPostingsHohishesHohishUuidPostingsGetOptions = (
  options: Options<GetPostingsHohishesHohishUuidPostingsGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPostingsHohishesHohishUuidPostingsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPostingsHohishesHohishUuidPostingsGetQueryKey(options),
  });
};

/**
 * Create Posting
 */
export const createPostingHohishesHohishUuidPostingsPostMutation = (
  options?: Partial<Options<CreatePostingHohishesHohishUuidPostingsPostData>>
): UseMutationOptions<
  CreatePostingHohishesHohishUuidPostingsPostResponse,
  CreatePostingHohishesHohishUuidPostingsPostError,
  Options<CreatePostingHohishesHohishUuidPostingsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePostingHohishesHohishUuidPostingsPostResponse,
    CreatePostingHohishesHohishUuidPostingsPostError,
    Options<CreatePostingHohishesHohishUuidPostingsPostData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createPostingHohishesHohishUuidPostingsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Posting
 */
export const deletePostingHohishesHohishUuidPostingsPostingUuidDeleteMutation = (
  options?: Partial<Options<DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteData>>
): UseMutationOptions<
  unknown,
  DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteError,
  Options<DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteError,
    Options<DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deletePostingHohishesHohishUuidPostingsPostingUuidDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Posting
 */
export const updatePostingHohishesHohishUuidPostingsPostingUuidPostMutation = (
  options?: Partial<Options<UpdatePostingHohishesHohishUuidPostingsPostingUuidPostData>>
): UseMutationOptions<
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostResponse,
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostError,
  Options<UpdatePostingHohishesHohishUuidPostingsPostingUuidPostData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdatePostingHohishesHohishUuidPostingsPostingUuidPostResponse,
    UpdatePostingHohishesHohishUuidPostingsPostingUuidPostError,
    Options<UpdatePostingHohishesHohishUuidPostingsPostingUuidPostData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updatePostingHohishesHohishUuidPostingsPostingUuidPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLegalEntityLegalEntitiesGetQueryKey = (
  options?: Options<GetLegalEntityLegalEntitiesGetData>
) => createQueryKey("getLegalEntityLegalEntitiesGet", options);

/**
 * Get Legal Entity
 */
export const getLegalEntityLegalEntitiesGetOptions = (
  options?: Options<GetLegalEntityLegalEntitiesGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLegalEntityLegalEntitiesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLegalEntityLegalEntitiesGetQueryKey(options),
  });
};

export const getSecurityPolicyPermerSecurityPolicyGetQueryKey = (
  options?: Options<GetSecurityPolicyPermerSecurityPolicyGetData>
) => createQueryKey("getSecurityPolicyPermerSecurityPolicyGet", options);

/**
 * Get Security Policy
 *
 * Get the security policy mapping roles to their allowed requirements.
 *
 * Returns the complete security policy that maps role names to lists
 * of permissions they are granted.
 */
export const getSecurityPolicyPermerSecurityPolicyGetOptions = (
  options?: Options<GetSecurityPolicyPermerSecurityPolicyGetData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSecurityPolicyPermerSecurityPolicyGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSecurityPolicyPermerSecurityPolicyGetQueryKey(options),
  });
};

export const statusStatusGetQueryKey = (options?: Options<StatusStatusGetData>) =>
  createQueryKey("statusStatusGet", options);

/**
 * Status
 */
export const statusStatusGetOptions = (options?: Options<StatusStatusGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await statusStatusGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: statusStatusGetQueryKey(options),
  });
};

export const statusDbStatusDbGetQueryKey = (options?: Options<StatusDbStatusDbGetData>) =>
  createQueryKey("statusDbStatusDbGet", options);

/**
 * Status Db
 */
export const statusDbStatusDbGetOptions = (options?: Options<StatusDbStatusDbGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await statusDbStatusDbGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: statusDbStatusDbGetQueryKey(options),
  });
};

export const boomBoomGetQueryKey = (options?: Options<BoomBoomGetData>) =>
  createQueryKey("boomBoomGet", options);

/**
 * Boom
 */
export const boomBoomGetOptions = (options?: Options<BoomBoomGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await boomBoomGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: boomBoomGetQueryKey(options),
  });
};
